import type {
    IFetcher,
    IFetchRequest,
    ILog,
    IProgressPromise,
    IProgressPromiseGenerator,
} from '@monofe/util';
import type { MediaBinaryStorageTypeMap } from '../interface/media';

const DEFAULT_TIMEOUT = 300000; /* 5 mins */
const DEFAULT_RETRY_COUNT = 2;

function download<
    K extends keyof MediaBinaryStorageTypeMap,
    V extends MediaBinaryStorageTypeMap[K],
>(
    promiser: IProgressPromiseGenerator,
    fetcher: IFetcher,
    logger: ILog,
    requests: IFetchRequest[],
    type: K,
    retryCount = DEFAULT_RETRY_COUNT,
    timeout = DEFAULT_TIMEOUT,
): IProgressPromise<V> {
    return promiser.async<V>(async progressCallback => {
        for (const request of requests) {
            const promise = fetcher<Blob | ArrayBuffer>(request, timeout, retryCount);

            promise.onProgress(progressCallback);

            const response = await promise;
            const payload = response.payload;
            if (!payload) {
                logger.error('Missing payload from media response');
                continue;
            }

            return payload as V;
        }

        throw new Error(`Failed to get response from requests: ${JSON.stringify(requests)}`);
    });
}

export default Object.freeze({
    download,
});
